import { createSelector } from 'reselect';

import { AllState } from '../../../state';

import { DEVELOPER_STORE_NAME } from '../developer.state';

import { REQUEST_LOGS_STORE_NAME, RequestLogsState } from './request-logs.state';

/** Select Request Logs State */
export const getRequestLogsState = (state: AllState): RequestLogsState =>
  state[DEVELOPER_STORE_NAME][REQUEST_LOGS_STORE_NAME];

export const isRequestLogsLoading = createSelector(
  getRequestLogsState,
  (requestLogs: RequestLogsState) => requestLogs && requestLogs.loading,
);

export const getRequestLogs = createSelector(
  getRequestLogsState,
  (requestLogs: RequestLogsState) => requestLogs && !requestLogs.loading && requestLogs.requestLogs,
);

export const getRequestLogsErrorMessage = createSelector(
  getRequestLogsState,
  (requestLogs: RequestLogsState) => requestLogs && requestLogs.error && requestLogs.error.message,
);

export const getRequestLogsApiResponse = createSelector(
  getRequestLogsState,
  (requestLogs: RequestLogsState) => requestLogs && requestLogs.response,
);
